import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { isSbsApp } from '../../../../src/common/utils/passUtil';
export default function SlideBanner(props) {

  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);


  useEffect(() => {
    const userAgent = navigator.userAgent;

    setIsIOS(/iPhone|iPad|iPod/i.test(userAgent));
    setIsAndroid(/Android/i.test(userAgent));
  }, []);

  const [swiper, setSwiper] = useState(null);

  useEffect(() => { }, []);

  const [touchX, setTouchX] = useState(0);
  const [touchY, setTouchY] = useState(0);

  const touchStart = (e) => {
    setTouchX(e.changedTouches[0].pageX);
    setTouchY(e.changedTouches[0].pageY);
  };

  const touchEnd = (e) => {
    const distanceX = touchX - e.changedTouches[0].pageX;
    const distanceY = touchY - e.changedTouches[0].pageY;
    const targetUl = e.target.closest('a');

    // 클릭인지 슬라이드 제스처인지 판단
    const isClick = Math.abs(distanceX) < 10 && Math.abs(distanceY) < 10; // 10px 이하면 클릭으로 판단

    if (isClick) {
      // 클릭인 경우 링크 동작 허용
      const href = targetUl?.href;
      if (href) {
        if (href.startsWith('siapp://')) {
          // 커스텀 스키마는 터치 이벤트에서 직접 처리
          try {
            window.location.href = href;
          } catch (error) {
            // 실패시 원본 URL로 이동
            const originalUrl = href.split('targeturl=')[1];
            if (originalUrl) {
              window.location.href = decodeURIComponent(originalUrl);
            }
          }
        } else {
          // 일반 링크는 바로 이동
          window.location.href = href;
        }
      }
      return;
    }

    // 슬라이드 제스처인 경우에만 처리
    if (targetUl) {
      const targetUlWidth = targetUl.offsetWidth / 2;
      const newLeft = Math.abs(parseFloat(targetUl.style.left)) + distanceX;

      if (newLeft < 0) {
        targetUl.style.left = '0px';
        // 좌로 이동
        swiper.slidePrev();
      } else if (newLeft < targetUlWidth) {
        targetUl.style.left = `-${newLeft}px`;
      } else {
        targetUl.style.left = `-${targetUlWidth}px`;
        // 우로 이동
        swiper.slideNext();
      }
    }
  };

  const getProcessedUrl = (item) => {
    if (isSbsApp() && item.link_url_m && item.link_url_m.includes('2025sbsgayosummer')) {   // 2025 가요대전 외부브라우저로 
      const encodedUrl = encodeURIComponent(item.link_url_m);
      return `siapp://browser?targeturl=${encodedUrl}`;
    }
    return item.link_url_m;
  };

  return (
    <>
      <div className="swiperBannerWrap">
        <Swiper
          onSwiper={(s) => {
            setSwiper(s);
          }}
          allowTouchMove={false} //수동 제어하기위해 멈춤
          // onSwiper={setSwiperRef}
          slidesPerView={1}
          mousewheel={false}
          loop={true}
          autoplay={true}
          pagination={{
            // 페이징 설정
            el: `.swiperBannerWrap .swiper-pagination`,
          }}
          navigation={{
            nextEl: `.swiperBannerWrap .swiper-button-next`,
            prevEl: `.swiperBannerWrap .swiper-button-prev`,
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="listModuleSlider"
          wrapperClass="SliderContent"
        >

          {props.data
            .filter((item) => {
              if (isSbsApp()) {
                if (isIOS) {
                  return item.ios_remove === 'N' || !item.hasOwnProperty('ios_remove');
                } else if (isAndroid) {
                  return item.and_remove === 'N' || !item.hasOwnProperty('and_remove');
                } else {
                  return true;
                }
              } else {
                return true;
              }
            })
            .map((item, index) => {
              // 디버깅을 위한 로그
              const shouldRemoveTarget = isSbsApp() && item.link_url_m?.includes('2025sbsgayosummer');

              return (
                <SwiperSlide
                  key={`swiper-slide-${index}`}
                  onTouchStart={touchStart}
                  onTouchEnd={touchEnd}
                >
                  <div className="listModuleItem swiper-slide">
                    {shouldRemoveTarget ? (
                      // 2025가요대전 배너는 target 없이 렌더링
                      <a
                        href={getProcessedUrl(item)}
                        className="swiperBnrLink"
                        style={{ backgroundColor: item.background_color }}
                        target={null}
                        onClick={(e) => {
                          // target 속성 강제 제거
                          e.target.removeAttribute('target');

                          const processedUrl = getProcessedUrl(item);

                          // 커스텀 스키마인 경우만 특별 처리
                          if (processedUrl.startsWith('siapp://')) {
                            e.preventDefault();
                            window.location.href = processedUrl;
                          }
                        }}
                        ref={(el) => {
                          // 렌더링 후 target 속성 강제 제거
                          if (el) {
                            el.removeAttribute('target');
                          }
                        }}
                      >
                        <img src={item.image_url_m} alt={item.image_text_m} />
                      </a>
                    ) : (
                      // 일반 배너는 target 포함
                      <a
                        href={getProcessedUrl(item)}
                        className="swiperBnrLink"
                        target={item.link_type_m}
                        style={{ backgroundColor: item.background_color }}
                        onClick={(e) => {
                          const processedUrl = getProcessedUrl(item);

                          if (processedUrl.startsWith('siapp://')) {
                            e.preventDefault();
                            window.location.href = processedUrl;
                          }
                        }}
                      >
                        <img src={item.image_url_m} alt={item.image_text_m} />
                      </a>
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
        <div className="swiper-pagination_w">
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </>
  );
}